<template>
   <v-container fluid>
      <v-row>
         <v-col cols="12" md="12">
            <v-toolbar dense :color="this.$globalstore.secondary_titleclass">
               <v-toolbar-title>
                  Create CCA Proposal
               </v-toolbar-title>
               <v-spacer></v-spacer>
               <v-btn color="indigo" class="white ma-2" outlined @click="saveProposal">
                  Submit
               </v-btn>
               <v-btn color="indigo" class="white" outlined @click="goBack()">
                  Back
               </v-btn>
            </v-toolbar>
            <v-card outlined class="text-center pa-10">
               <h1>
                  [HIS] Internal CCA Proposal Form for AY
                  {{ $globalstore.appsettings.proposal_year }}
                  {{ $globalstore.appsettings.proposal_term }}
               </h1>
            </v-card>
            <v-card outlined class="px-md-16 px-5 pt-5 mt-5 text-md-subtitle-1">
               After much consideration, we have decided to revert back to running CCA by terms.
               Each teacher is required to run at least ONE (1) CCA per term. Kindly read below
               before proposing your CCA for the new academic year:
               <ul>
                  <li>
                     Please fill up ALL sections of the form so that we can make the most suitable
                     allocations.
                  </li>
                  <li>
                     The CCA team will be vetting through these proposals, please take note that
                     CCA's submitted are NOT CONFIRMED until informed otherwise. Likewise, the CCA
                     team reserve the right to decide on the day of the week that the CCA will run
                     on.
                  </li>
                  <li>
                     If staff fail to submit a CCA proposal by the set deadline, then they will be
                     automatically assigned to a CCA / duty.
                  </li>
                  <li>
                     Auditions are only opened for Production CCA at the moment. If you would like
                     your CCA to be selection-based, please inform us via email.
                  </li>
                  <li>
                     MP1 (Year 1 &amp; 2) CCA will be moved to after-school hours and ran alongside
                     other year groups.
                  </li>
                  <li>
                     Staff will no longer be able to offer an academic booster as a CCA for
                     students.
                  </li>
                  <li>
                     <strong
                        >Please note that Assisting Teacher may only attach to existing proposals
                        submitted by Leading Teacher.
                     </strong>
                  </li>
                  <li>
                     By submitting this proposal, I acknowledge that I have read, understand, and
                     agree on the terms stated on the cover page.
                  </li>
               </ul>
            </v-card>

            <v-card outlined class="mt-5">
               <p class="px-10 pt-5">Name<span class="red--text"> * </span></p>
               <v-text-field class="px-10" v-model="edit_proposer_name" readonly> </v-text-field>
            </v-card>

            <v-card outlined class="mt-5 card-project">
               <p class="px-10 pt-5">
                  Have you already agreed to be involved in one of the following CCA's?
                  <span class="red--text"> * </span>
               </p>
               <v-radio-group class="pl-10" v-model="edit_otherproject">
                  <v-radio label="Sports Team" value="Sports Team"></v-radio>
                  <v-radio label="Project Purpose" value="Project Purpose"></v-radio>
                  <v-radio label="Production" value="Production"></v-radio>
                  <v-radio label="Not Applicable" value="Not Applicable"></v-radio>
               </v-radio-group>
            </v-card>
            <v-card flat class="text--disabled mt-5 pl-10">
               Proposed CCA
            </v-card>
            <v-card outlined class="px-10 mt-5 card-role">
               <p class="mt-5">Role in CCA<span class="red--text"> * </span></p>
               <p>
                  Please note that CCA's should only have assisting teachers where absolutely
                  necessary due to a high number of students in the CCA, or because the CCA teaches
                  specific skills where multiple teachers are required. The CCA team reserves the
                  right to re-allocate assisting teachers when necessary.
               </p>
               <v-row>
                  <v-col cols="12" md="2">
                     <v-radio-group v-model="edit_cca_role" @change="roleChanged">
                        <v-radio label="Lead Teacher" value="1"></v-radio>
                        <v-radio ref="asst" label="Assisting Teacher" value="2"></v-radio>
                     </v-radio-group>
                  </v-col>
                  <v-col cols="12" md="8" :align-self="$vuetify.breakpoint.mdAndUp ? 'end' : ''">
                     <v-autocomplete
                        v-if="edit_cca_role === CCA_ROLE.ASSISTING_TEACHER"
                        class="pt-0 pb-2"
                        dense
                        v-model="selectedproposal"
                        :items="proposallist"
                        label="Select Proposal"
                        item-text="cca_name"
                        return-object
                        @change="onSelectProposal"
                     >
                        <template v-slot:item="data">
                           <v-row dense>
                              <v-col>
                                 <v-list-item-content>
                                    {{ data.item.cca_name }}
                                 </v-list-item-content>
                              </v-col>
                              <v-col>
                                 <v-list-item-content>
                                    {{ data.item.proposer_name }}
                                 </v-list-item-content>
                              </v-col>
                              <v-col>
                                 <v-list-item-content>
                                    {{ data.item.yeargrouptext }}
                                 </v-list-item-content>
                              </v-col>
                           </v-row>
                        </template>
                     </v-autocomplete>
                  </v-col>
               </v-row>
            </v-card>
            <v-card outlined class="mt-5 card-ccaname">
               <p class="px-10 pt-5">
                  Name of CCA
                  <span class="red--text"> * </span>
               </p>
               <v-text-field
                  v-model="edit_cca_name"
                  single-line
                  class="px-10 mt-n2"
                  :rules="[(v) => (v && v.length <= 100) || 'Max 100 characters']"
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
               >
               </v-text-field>
            </v-card>
            <v-card flat class="text--disabled mt-5 pl-10">
               CCA Proposal Details &amp; Info
            </v-card>
            <v-card outlined class="px-10 pt-5 mt-5 card-description">
               <p>
                  Description/Outline of Activity (for students and parents to understand your CCA
                  better)<span class="red--text"> * </span>
               </p>
               <v-text-field
                  v-model="edit_cca_description"
                  single-line
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  type="text"
                  :counter="DescriptionMaxLength"
                  :maxlength="DescriptionMaxLength"
               ></v-text-field>
            </v-card>
            <v-card outlined class="px-10 pt-5 mt-5 card-location">
               <p>
                  Preferred Venue for CCA (if you are unsure, please let us know the requirement for
                  space like tables needed/ need enough space for physical activities/etc. You might
                  not be using this venue.)<span class="red--text">
                     *
                  </span>
               </p>
               <v-text-field
                  v-model="edit_location_requirement"
                  single-line
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  type="text"
                  maxlength="100"
                  counter="100"
               ></v-text-field>
            </v-card>
            <v-card outlined class="px-10 pt-5 mt-5 card-maxparticipant">
               <p>
                  Maximum number of students in the CCA (Minimum number of students is 10pax)<span
                     class="red--text"
                  >
                     *
                  </span>
               </p>
               <v-text-field
                  v-model="edit_max_participant"
                  single-line
                  :rules="rules_max_participant"
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
               ></v-text-field>
            </v-card>
            <v-card outlined class="px-10 pt-5 mt-5 card-eventday">
               Preferred Day for CCA
               <v-radio-group
                  v-model="edit_eventday"
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
               >
                  <v-radio label="Monday" value="1"></v-radio>
                  <v-radio label="Tuesday" value="2"></v-radio>
                  <v-radio label="Wednesday" value="3"></v-radio>
                  <v-radio label="Thursday" value="4"></v-radio>
               </v-radio-group>
            </v-card>
            <!-- <v-card outlined class="px-10 pt-5 mt-5 card-timeslot">
               <p>
                  CCA Timing 3:30pm - 5:00pm (we might contact you for further
                  clarification and approval)<span class="red--text"> * </span>
               </p>

               <v-radio-group
                  v-model="edit_duration"
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
               >
                  <v-radio label="50 minutes" value="50"></v-radio>
                  <v-radio label="90 minutes" value="90"></v-radio>
               </v-radio-group>
            </v-card> -->
            <v-card outlined class="px-10 pt-5 mt-5 card-category">
               <p>
                  Which category is your CCA in?
                  <span class="red--text"> * </span>
               </p>

               <v-radio-group
                  v-model="edit_category"
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
               >
                  <v-radio label="Academic/Intellectual" value="1"></v-radio>
                  <v-radio label="Creative Arts" value="2"></v-radio>
                  <v-radio label="Language/Cultural" value="3"></v-radio>
                  <v-radio label="Music/Performing Arts" value="4"></v-radio>
                  <v-radio label="Sports/Physical" value="5"></v-radio>
                  <v-radio label="Technology" value="6"></v-radio>
               </v-radio-group>
            </v-card>

            <v-card outlined class="px-10 pt-5 mt-5 card-mastery">
               <p>
                  How does it link to HELP International School's Masteries?<span class="red--text">
                     *
                  </span>
               </p>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  v-model="edit_cca_mastery"
                  label="Leadership"
                  value="1"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_cca_mastery"
                  label="Moral"
                  value="2"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_cca_mastery"
                  label="Emotional"
                  value="3"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_cca_mastery"
                  label="Intellectual"
                  value="4"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_cca_mastery"
                  label="Career"
                  value="5"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_cca_mastery"
                  label="Physical"
                  value="6"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_cca_mastery"
                  label="Creative"
                  value="7"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_cca_mastery"
                  label="Social"
                  value="8"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_cca_mastery"
                  label="Technology"
                  value="9"
               ></v-checkbox>
            </v-card>
            <v-card outlined class="px-10 pt-5 mt-5 card-yeargroup">
               <p>
                  This CCA is opened for year group(s)
                  <span class="red--text"> * </span>
               </p>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  v-model="edit_yeargroup"
                  label="Year 1"
                  value="1"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_yeargroup"
                  label="Year 2"
                  value="2"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_yeargroup"
                  label="Year 3"
                  value="3"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_yeargroup"
                  label="Year 4"
                  value="4"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_yeargroup"
                  label="Year 5"
                  value="5"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_yeargroup"
                  label="Year 6"
                  value="6"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_yeargroup"
                  label="Year 7"
                  value="7"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_yeargroup"
                  label="Year 8"
                  value="8"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_yeargroup"
                  label="Year 9"
                  value="9"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_yeargroup"
                  label="Year 10"
                  value="10"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_yeargroup"
                  label="Year 11"
                  value="11"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_yeargroup"
                  label="Year 12"
                  value="12"
               ></v-checkbox>
               <v-checkbox
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  dense
                  class="my-n2 py-0"
                  v-model="edit_yeargroup"
                  label="Year 13"
                  value="13"
               ></v-checkbox>
            </v-card>
            <v-card outlined class="px-10 pt-5 mt-5 card-materialtool">
               <p>
                  Please list the main materials / tools which will be used in your CCA.<span
                     class="red--text"
                  >
                     *
                  </span>
               </p>
               <v-text-field
                  v-model="edit_material_toolusage"
                  type="text"
                  single-line
                  :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                  :counter="MaterialToolUsageMaxLength"
                  :maxlength="MaterialToolUsageMaxLength"
               ></v-text-field>
            </v-card>
            <v-card outlined class="px-10 pt-5 mt-5 card-fee">
               <p>
                  Are fees required for this CCA? If yes, please state what it is for (compulsory
                  trips, equipment, registration fee, etc) and what is the estimated fee.
                  <span class="red--text"> * </span>
               </p>
               <v-row no-gutters>
                  <v-col cols="12" md="2">
                     <v-radio-group
                        v-model="edit_cca_fee"
                        :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                     >
                        <v-radio label="No" value="0"></v-radio>
                        <v-radio label="Other" value="1"> </v-radio>
                     </v-radio-group>
                  </v-col>
                  <v-col cols="12" md="8" align-self="end">
                     <span v-show="edit_cca_fee == 1">
                        <v-text-field
                           placeholder="Please describe fees required."
                           class="mt-n2 py-0"
                           v-model="edit_fee_description"
                           single-line
                           :readonly="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                        ></v-text-field>
                     </span>
                  </v-col>
               </v-row>
            </v-card>
            <v-card outlined class="px-10 pt-5 mt-5 card-byomt">
               <p>
                  Are students required to bring their own tools or material for the CCA? If yes,
                  please state what it is.
                  <span class="red--text"> * </span>
               </p>
               <v-row no-gutters>
                  <v-col cols="12" md="2">
                     <v-radio-group
                        v-model="edit_own_material"
                        :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                     >
                        <v-radio label="No" value="0"></v-radio>
                        <v-radio label="Other" value="1"></v-radio>
                     </v-radio-group>
                  </v-col>
                  <v-col cols="12" md="8" align-self="end">
                     <span v-show="edit_own_material == '1'">
                        <v-text-field
                           placeholder="Please describe materials or tools required."
                           class="mt-n2 py-0"
                           v-model="edit_material_requirement"
                           single-line
                           :disabled="edit_cca_role == CCA_ROLE.ASSISTING_TEACHER"
                        ></v-text-field>
                     </span>
                  </v-col>
               </v-row>
            </v-card>

            <v-card flat class="text-center pt-10">
               End of Form. Created by HELP International School
            </v-card>

            <v-row justify="space-around" class="py-10">
               <v-col cols="6" md="3">
                  <v-btn color="primary" block @click="saveProposal">
                     Submit
                  </v-btn>
               </v-col>
               <v-col cols="6" md="3">
                  <v-btn color="primary" block @click="goBack()">
                     Back
                  </v-btn>
               </v-col>
            </v-row>
         </v-col>
      </v-row>
      <show-toast ref="toast"></show-toast>
      <v-sheet> </v-sheet>
   </v-container>
</template>

<script>
   import showToast from "@/components/showToast.vue";
   import {DESCRIPTION_MAXLENGTH} from "@/common/constant.js";
   export default {
      components: {showToast},

      inject: ["ShowMessage"],

      data() {
         return {
            DescriptionMaxLength: DESCRIPTION_MAXLENGTH,
            MaterialToolUsageMaxLength: 100,
            CCA_ROLE: {
               LEAD_TEACHER: "1",
               ASSISTING_TEACHER: "2",
            },
            edit_acknowledged: "",
            edit_proposer_name: this.$globalstore.user.username,
            edit_otherproject: "",
            edit_cca_role: "1",
            edit_cca_name: "",
            edit_cca_description: "",
            edit_location_requirement: "",
            edit_max_participant: "",
            edit_eventday: "",
            edit_duration: "50",
            edit_category: "",
            edit_cca_mastery: [],
            edit_yeargroup: [],
            edit_material_toolusage: "",
            edit_fee_description: "",
            edit_cca_fee: "",
            edit_own_material: "0",
            edit_material_requirement: "",
            rules_max_participant: [
               (v) => !!/^[0-9]+$/.test(v) || "Max participants must be numeric.",
            ],
            proposallist: [],
            selectedproposal: null,
         };
      },
      methods: {
         goBack() {
            this.$router.go(-1);
         },

         onSelectProposal() {
            this.edit_cca_name = this.selectedproposal.cca_name;
            this.edit_cca_description = this.selectedproposal.cca_description;
            this.edit_location_requirement = this.selectedproposal.location_requirement;
            this.edit_max_participant = this.selectedproposal.max_participant;
            this.edit_eventday = this.selectedproposal.preferred_eventday.toString();
            //this.edit_duration = this.selectedproposal.duration;
            this.edit_category = this.selectedproposal.cca_category.toString();
            this.edit_cca_mastery = this.selectedproposal.mastery.map(String);
            this.edit_yeargroup = this.selectedproposal.yeargroup.map(String);
            this.edit_material_toolusage = this.selectedproposal.materialtool_usage;
            this.edit_cca_fee = this.selectedproposal.cca_fee_required;
            this.edit_cca_fee_description = this.selectedproposal.cca_fee_description;
            this.edit_own_material = this.selectedproposal.own_material;
            this.edit_material_requirement = this.selectedproposal.material_requirement;
         },

         roleChanged() {
            this.edit_cca_name = "";
            this.edit_cca_description = "";
            this.edit_location_requirement = "";
            this.edit_max_participant = "";
            this.edit_eventday = "";
            //this.edit_duration = "";
            this.edit_category = "";
            this.edit_cca_mastery = [];
            this.edit_yeargroup = [];
            this.edit_material_toolusage = "";
            this.edit_cca_feee = "";
            this.edit_cca_fee_description = "";
            this.edit_own_material = "0";
            this.edit_material_requirement = "";
            this.selectedproposal = null;
         },

         async checkGroupName() {
            await this.$http({
               url: "/cca/checkgroupname.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  groupname: this.edit_cca_name,
                  cca_year: this.$globalstore.appsettings.proposal_year,
                  cca_term: this.$globalstore.appsettings.proposal_term,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     if (this.edit_cca_role == this.CCA_ROLE.ASSISTING_TEACHER) {
                        if (!response.data.groupnamefound) {
                           this.ShowMessage({
                              title: "Error",
                              message: "CCA name not found.",
                              color: "red",
                           });
                           this.edit_cca_name = "";
                           this.edit_cca_role = this.CCA_ROLE.LEAD_TEACHER;
                           this.$vuetify.goTo(".card-ccaname");
                           return;
                        }
                     } else if (this.edit_cca_role == this.CCA_ROLE.LEAD_TEACHER) {
                        if (response.data.groupnamefound) {
                           this.ShowMessage({
                              title: "Error",
                              message: "CCA name already exist. Please use another name.",
                              color: "red",
                           });
                           this.$vuetify.goTo(".card-ccaname");
                           return;
                        }
                     }
                  }
               }
            });
         },

         CheckProposal() {
            if (!this.edit_otherproject) {
               this.ShowMessage({
                  title: "Error",
                  message: "Involvement in other projects is required.",
                  color: "red",
               });
               this.$vuetify.goTo(".card-project");
               return false;
            }

            if (!this.edit_cca_name) {
               this.ShowMessage({
                  title: "Error",
                  message: "CCA name is required.",
                  color: "red",
               });
               this.$vuetify.goTo(".card-ccaname");
               return false;
            }

            if (this.edit_cca_name.length > 100) {
               this.ShowMessage({
                  title: "Error",
                  message: "CCA name is more than 100 characters.",
                  color: "red",
               });
               this.$vuetify.goTo(".card-ccaname");
               return false;
            } else {
               this.checkGroupName();
            }

            if (this.edit_cca_description.length > 1024) {
               this.ShowMessage({
                  title: "Error",
                  message: "CCA description is more than 1024 characters.",
                  color: "red",
               });
               this.$vuetify.goTo(".card-ccaname");
               return false;
            }

            if (!this.edit_cca_role) {
               this.ShowMessage({
                  title: "Error",
                  message: "CCA role is required.",
                  color: "red",
               });
               this.$vuetify.goTo(".card-role");
               return false;
            }

            if (this.edit_cca_role == this.CCA_ROLE.LEAD_TEACHER) {
               if (!this.edit_cca_description) {
                  this.ShowMessage({
                     title: "Error",
                     message: "CCA description is required.",
                     color: "red",
                  });
                  this.$vuetify.goTo(".card-description");
                  return false;
               }
            }

            if (this.edit_cca_role == this.CCA_ROLE.LEAD_TEACHER) {
               if (!this.edit_location_requirement) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Location requirements is required.",
                     color: "red",
                  });
                  this.$vuetify.goTo(".card-location");
                  return false;
               }
            }

            if (this.edit_cca_role == this.CCA_ROLE.LEAD_TEACHER) {
               if (!this.edit_max_participant || !/^[0-9]+$/.test(this.edit_max_participant)) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Maximum participants is required and must be numeric.",
                     color: "red",
                  });
                  this.$vuetify.goTo(".card-maxparticipant");
                  return false;
               }
            }

            // if (this.edit_cca_role == this.CCA_ROLE.LEAD_TEACHER) {
            //    if (!this.edit_duration) {
            //       this.ShowMessage({
            //          title: "Error",
            //          message: "CCA time slot is required.",
            //          color: "red",
            //       });
            //       this.$vuetify.goTo(".card-timeslot");
            //       return false;
            //    }
            // }

            if (this.edit_cca_role == this.CCA_ROLE.LEAD_TEACHER) {
               if (!this.edit_category) {
                  this.ShowMessage({
                     title: "Error",
                     message: "CCA category is required.",
                     color: "red",
                  });
                  this.$vuetify.goTo(".card-category");
                  return false;
               }
            }

            if (this.edit_cca_role == this.CCA_ROLE.LEAD_TEACHER) {
               if (this.edit_cca_mastery.length === 0) {
                  this.ShowMessage({
                     title: "Error",
                     message: "HELP Internationl School Masteries is required.",
                     color: "red",
                  });
                  this.$vuetify.goTo(".card-mastery");
                  return false;
               }
            }

            if (this.edit_cca_role == this.CCA_ROLE.LEAD_TEACHER) {
               if (this.edit_yeargroup.length === 0) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Year group is required.",
                     color: "red",
                  });
                  this.$vuetify.goTo(".card-yeargroup");
                  return false;
               }
            }

            if (this.edit_cca_role == this.CCA_ROLE.LEAD_TEACHER) {
               if (!this.edit_material_toolusage) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Materials or tools usage is required.",
                     color: "red",
                  });
                  this.$vuetify.goTo(".card-materialtool");
                  return false;
               }
            }

            if (this.edit_cca_role == this.CCA_ROLE.LEAD_TEACHER) {
               if (!this.edit_cca_fee) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Please specify if any fees are required.",
                     color: "red",
                  });
                  this.$vuetify.goTo(".card-fee");
                  return false;
               }
            }

            if (this.edit_cca_role == this.CCA_ROLE.LEAD_TEACHER) {
               if (this.edit_cca_fee == "1" && !this.edit_fee_description) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Please describe the fees required.",
                     color: "red",
                  });
                  return false;
               }
            }

            if (this.edit_cca_role == this.CCA_ROLE.LEAD_TEACHER) {
               if (this.edit_own_material == "1" && !this.edit_material_requirement) {
                  this.ShowMessage({
                     title: "Error",
                     message: "Please specify if any materials are required.",
                     color: "red",
                  });
                  this.$vuetify.goTo(".card-byomt");
                  return false;
               }
            }

            return true;
         },

         saveProposal() {
            if (this.CheckProposal()) {
               this.doSaveProposal();
            }
         },

         async doSaveProposal() {
            await this.$http({
               url: "/cca/saveproposal.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_year: this.$globalstore.appsettings.proposal_year,
                  cca_term: this.$globalstore.appsettings.proposal_term,
                  proposer_name: this.edit_proposer_name,
                  other_project: this.edit_otherproject,
                  cca_name: this.edit_cca_name,
                  cca_role: this.edit_cca_role,
                  cca_description: this.edit_cca_description,
                  cca_location: this.edit_location_requirement,
                  max_participant: this.edit_max_participant,
                  event_day: this.edit_eventday,
                  event_timeslot: this.edit_duration,
                  cca_category: this.edit_category,
                  cca_mastery: this.edit_cca_mastery,
                  materialtoolusage: this.edit_material_toolusage,
                  fee_required: this.edit_cca_fee,
                  fee_description: this.edit_fee_description,
                  own_material: this.edit_own_material,
                  material_requirement: this.edit_material_requirement,
                  cca_mastery: this.edit_cca_mastery,
                  cca_yeargroup: this.edit_yeargroup,
                  userid: this.$globalstore.user.userid, // this is also the proposer id
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                     this.$router.go(-1);
                  }
               }
            });
         },

         async loadProposalList() {
            await this.$http({
               url: "/cca/getavailableproposal.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_year: this.$globalstore.appsettings.proposal_year,
                  cca_term: this.$globalstore.appsettings.proposal_term,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.proposallist = response.data.availableproposal;
                  }
               }
            });
         },
      },
      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.loadProposalList();
         }
      },
   };
</script>
